import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { WarningCircle } from "@phosphor-icons/react";

export default function DemoBadge() {
    const [mode, setMode] = useState(null);
    useEffect(() => {
        api.get("/app/config").then((r) => setMode(r.data.mode)).catch(() => {});
    }, []);
    if (mode !== "demo") return null;
    return (
        <div className="bg-[#E8A33A]/15 border-b border-[#E8A33A]/40 text-[#8a5e10]" data-testid="demo-badge">
            <div className="container-page py-1.5 text-xs sm:text-sm flex items-center justify-center gap-2 font-semibold">
                <WarningCircle size={14} weight="fill" />
                Modo demostración — datos de ejemplo. No representan clientes ni transacciones reales.
            </div>
        </div>
    );
}
